/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Share_CalendarInputs */

const en_us2_share_share_calendar = /** @type {(inputs: Share_Share_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the month's calendar`)
};

const pt_br2_share_share_calendar = /** @type {(inputs: Share_Share_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar o calendário do mês`)
};

const es_419_share_share_calendar = /** @type {(inputs: Share_Share_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir el calendario del mes`)
};

const pt_pt2_share_share_calendar = /** @type {(inputs: Share_Share_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partilhar o calendário do mês`)
};

const fr_fr2_share_share_calendar = /** @type {(inputs: Share_Share_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager le calendrier du mois`)
};

const de_de2_share_share_calendar = /** @type {(inputs: Share_Share_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatskalender teilen`)
};

const it_it2_share_share_calendar = /** @type {(inputs: Share_Share_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi il calendario del mese`)
};

/**
* | output |
* | --- |
* | "Share the month's calendar" |
*
* @param {Share_Share_CalendarInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_share_calendar = /** @type {((inputs?: Share_Share_CalendarInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Share_CalendarInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_share_calendar(inputs)
	if (locale === "es-419") return es_419_share_share_calendar(inputs)
	if (locale === "pt-PT") return pt_pt2_share_share_calendar(inputs)
	if (locale === "fr-FR") return fr_fr2_share_share_calendar(inputs)
	if (locale === "de-DE") return de_de2_share_share_calendar(inputs)
	if (locale === "it-IT") return it_it2_share_share_calendar(inputs)
	return en_us2_share_share_calendar(inputs)
});
export { share_share_calendar as "share.share_calendar" }